import classNames from "classnames";
import SVGClose from "../../icons/Close.svg?react";
import SVGSearch from "../../icons/Search.svg?react";
import Icon from "./Icon";
import styles from "./SearchBar.module.css";

interface Props {
  placeholder?: string;
  value: string;
  onChange?: (s: string) => void;
  className?: string;
  id?: string;
}

const SearchBar = ({ placeholder, value, onChange, className, id }: Props) => (
  <div className={classNames(styles.search, className)}>
    <input
      id={id}
      type="search"
      placeholder={placeholder ?? ""}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
    />
    {value === "" && <Icon glyph={SVGSearch} className={styles.searchIcon} />}
    {value !== "" && (
      <Icon
        glyph={SVGClose}
        className={styles.clearIcon}
        onClick={() => onChange?.("")}
      />
    )}
  </div>
);

export default SearchBar;
